import { getAscendantCodes } from "@l2r-front/l2r-utils"

import { useHorizontalSignTypes } from "../queries/horizontalSigning/useHorizontalSignTypes"

export function useHorizontalSignAscendantCodes(code) {
    const { data: horizontalSignTypes } = useHorizontalSignTypes()

    return getAscendantCodes(code, horizontalSignTypes)
}